/* Dear eM — điện thoại: ảnh sản phẩm dính trên cùng khi kéo xuống chọn Dòng/Màu (Claude v22.5)
   1) PDP: ô ảnh listing sticky cho tới khi kéo qua hết mục chọn variant thì mới ẩn → chọn màu thấy ảnh đổi ngay
   2) Popup thiết kế thêu (customizer): khung xem trước sticky phía trên, phần chỉnh sửa cuộn bên dưới
   v22.9: 3) thanh sticky "Thêu tên lên túi này": bỏ chữ "Cá nhân hoá miễn phí…", thay bằng GIÁ biến thể đang chọn (tự đổi khi đổi variant)
          4) gọn khoảng trắng ảnh/slider trên điện thoại: khung ảnh vuông đồng đều, nút slider nổi trên ảnh */
(function () {
  if (window.__dmStick) return; window.__dmStick = 1;
  if (!/\/products\//.test(location.pathname)) return;
  var mq = window.matchMedia('(max-width: 749px)');
  var st = document.createElement('style');
  st.textContent =
    '@media (max-width:749px){' +
      /* lưới 1 cột của Dawn khiến sticky không chạy (ô lưới chỉ cao bằng ảnh) → đổi về khối thường */
      '.product.grid:has(>.dm-stick-media){display:block!important}' +
      '.product.grid:has(>.dm-stick-media)>.product__info-wrapper{margin-top:1rem}' +
      '.dm-stick-media{position:sticky;z-index:2;background:#fff;transition:box-shadow .2s}' +
      '.dm-stick-media.is-stuck{box-shadow:0 8px 18px rgba(31,27,36,.12)}' +
      '.dm-stick-media.dm-stick-off{position:relative;box-shadow:none}' +
      /* v22.5: chỉ dính ảnh chính, ẩn dải ảnh nhỏ trên điện thoại (khách tự vuốt trái/phải) */
      '.product__media-wrapper .thumbnail-slider,.product__media-wrapper .thumbnail-list{display:none!important}' +
      '.product__media-wrapper .slider-buttons{display:flex!important}' +
      /* v22.9: mọi ảnh cùng khung vuông → hết khoảng trắng trên/dưới ảnh vuông khi listing có ảnh dọc */
      '.product__media-wrapper .product__media-list{margin-bottom:0!important;align-items:flex-start}' +
      '.product__media-wrapper .product__media-item{padding-top:0!important;padding-bottom:0!important}' +
      '.product__media-wrapper .product-media-container{--ratio-percent:100%!important;width:100%!important;max-width:100%!important;margin:0!important;background:#f6f6f6}' +
      '.product__media-wrapper .product-media-container .media{padding-top:100%!important}' +
      /* v22.9: nút ‹ 1/8 › nổi trên đáy ảnh thay vì chiếm 1 hàng riêng */
      '.product__media-wrapper slider-component[id^="GalleryViewer"]{position:relative}' +
      '.product__media-wrapper slider-component[id^="GalleryViewer"] .slider-buttons{position:absolute;left:50%;bottom:.8rem;transform:translateX(-50%);z-index:3;margin:0!important;padding:0 .2rem;height:3rem;min-height:0;align-items:center;background:rgba(255,255,255,.9);border-radius:999px;box-shadow:0 2px 8px rgba(0,0,0,.12)}' +
      '.product__media-wrapper slider-component[id^="GalleryViewer"] .slider-button{width:3rem;height:3rem;min-width:0;padding:0}' +
      '.product__media-wrapper slider-component[id^="GalleryViewer"] .slider-counter{font-size:1.2rem;min-width:3.6rem;margin:0}' +
    '}' +
    /* v22.9: giá trong thanh sticky */
    '.dmc-sticky__txt.dm-sp{flex:0 0 auto;display:flex;flex-direction:column;align-items:flex-start;justify-content:center;line-height:1.15}' +
    '.dmc-sticky__txt.dm-sp .dm-sp__now{font-size:1.8rem;font-weight:700;color:#222;white-space:nowrap}' +
    '.dmc-sticky__txt.dm-sp .dm-sp__was{font-size:1.2rem;color:#8a8590;white-space:nowrap}' +
    '@media (max-width:860px){' +
      '.dmc-modal__dialog .dmc-stage{position:sticky;top:0;z-index:5;background:#fff;box-shadow:0 6px 14px rgba(31,27,36,.08)}' +
      '.dmc-modal__dialog .dmc-tabs{top:var(--dm-stage-h,0px)!important}' +
    '}';
  document.head.appendChild(st);

  function headerBottom() {
    var h = document.querySelector('sticky-header, .section-header');
    if (!h) return 0;
    var cs = getComputedStyle(h.closest('.section-header') || h);
    if (cs.position !== 'sticky' && cs.position !== 'fixed') return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 && r.top <= 0.5 ? Math.round(r.bottom) : 0;
  }
  var ticking = false;
  function update() {
    ticking = false;
    var m = document.querySelector('.product__media-wrapper');
    var v = document.querySelector('.product__info-wrapper variant-selects') || document.querySelector('variant-selects');
    if (!m) return;
    if (!mq.matches || !v || v.offsetParent === null) {
      m.classList.remove('dm-stick-media', 'dm-stick-off', 'is-stuck'); m.style.top = ''; return;
    }
    if (!m.classList.contains('dm-stick-media')) m.classList.add('dm-stick-media');
    var top = headerBottom();
    if (m.style.top !== top + 'px') m.style.top = top + 'px';
    var mh = m.offsetHeight;
    var off = v.getBoundingClientRect().bottom < top + mh;   // đã kéo qua hết mục chọn variant
    m.classList.toggle('dm-stick-off', off);
    m.classList.toggle('is-stuck', !off && m.getBoundingClientRect().top <= top + 1 && window.scrollY > 0);
  }
  function req() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', req, { passive: true });
  window.addEventListener('resize', req);
  document.addEventListener('change', function () { setTimeout(req, 50); setTimeout(stickyPrice, 80); setTimeout(stickyPrice, 700); });
  setInterval(req, 800);

  /* v22.9: giá biến thể trong thanh sticky — lấy đúng giá theme đang hiển thị (Dawn tự cập nhật khi đổi variant) */
  function txt(e) { return e ? e.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function stickyPrice() {
    var box = document.querySelector('.dmc-sticky__txt');
    if (!box) return;
    var pb = document.querySelector('.product__info-wrapper [id^="price-"] .price') || document.querySelector('[id^="price-"] .price');
    if (!pb) return;
    var now = '', was = '';
    if (pb.classList.contains('price--on-sale')) {
      now = txt(pb.querySelector('.price__sale .price-item--sale'));
      was = txt(pb.querySelector('.price__sale .price-item--regular'));
    }
    if (!now) now = txt(pb.querySelector('.price__regular .price-item--regular')) || txt(pb.querySelector('.price-item'));
    if (!now) return;
    var html = '<b class="dm-sp__now">' + esc(now) + '</b>' + (was && was !== now ? '<s class="dm-sp__was">' + esc(was) + '</s>' : '');
    if (box.__dmHtml !== html) { box.__dmHtml = html; box.innerHTML = html; box.classList.add('dm-sp'); }
  }
  setInterval(stickyPrice, 400);

  /* chiều cao khung xem trước → tab trong popup dính ngay bên dưới */
  function stageVar() {
    var s = document.querySelector('.dmc-modal__dialog .dmc-stage'), d = s && s.closest('.dmc-modal__dialog');
    if (!s || !d) return;
    var h = mq.matches || window.innerWidth <= 860 ? s.offsetHeight : 0;
    d.style.setProperty('--dm-stage-h', h + 'px');
  }
  setInterval(stageVar, 500);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', function () { req(); stickyPrice(); }) : (req(), stickyPrice());
})();
